import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { dashBoardEndPoints, SCHOOL } from "../../../api/apiEndPoints";
import APICallService from "../../../api/apiCallService";
import { SidebarTitle } from "../../../utils/string";
import Method from "../../../utils/methods";
import Loader from "../../../Global/loader";

const VendorSchoolRecently = (props: any) => {
  const [loading, setLoading] = useState(true);
  const [vendorloading, setVendorLoading] = useState(true);
  const [schoolList, setSchoolList] = useState([]);
  const [vendorsList, setVendorsList] = useState([]);

  useEffect(() => {
    (async () => {
      setLoading(true);
      await fetchSchoolList(1, 5);
      await fetchVendorList(1, 5);
      setLoading(false);
    })();
  }, []);

  const fetchSchoolList = async (pageNo: number, limit: number) => {
    setLoading(true);
    let params = {
      pageNo: pageNo,
      limit: limit,
      sortKey: "createdAt",
      sortOrder: -1,
    };
    let apiService = new APICallService(SCHOOL.GET_SCHOOL_LIST, params);
    let response = await apiService.callAPI();
    if (response) {
      setSchoolList(response.records);
    }
    setLoading(false);
  };

  const fetchVendorList = async (pageNo: number, limit: number) => {
    setVendorLoading(true);
    let params = {
      pageNo: pageNo,
      limit: limit,
      sortKey: "createdAt",
      sortOrder: -1,
    };
    let apiService = new APICallService(
      dashBoardEndPoints.GET_RECENTLY_VENDORSLIST,
      params
    );
    let response = await apiService.callAPI();
    if (response) {
      setVendorsList(response.records);
    }
    setVendorLoading(false);
  };

  return (
    <Card className="bg-f9f9f9">
      <Card.Body>
        <Row className="gy-6">
          <Col lg={6}>
            <Card className="bg-white h-100">
              <Card.Header className="d-flex justify-content-between align-items-center">
                <h3 className="card-title fs-20 fw-bolder text-dark">
                  {SidebarTitle.Schools}
                </h3>
                <a
                  href="/all-schools"
                  className="btn fs-16 text-primary btn-link p-0 ms-3"
                >
                  View all
                </a>
              </Card.Header>
              <Card.Body>
                {!loading ? (
                  schoolList?.length ? (
                    schoolList?.map((val: any, index: number) => (
                      <div key={index}>
                        <div className="d-flex align-items-center mb-4">
                          <div className="symbol symbol-50px me-5">
                            <img src={val?.image} alt="Profile" />
                          </div>
                          <div className="flex-grow-1">
                            <div className="text-dark fw-bold fs-6">
                              {val?.name}
                            </div>
                            <span className="text-muted d-block fw-semibold">
                              {val?.user?.email}
                            </span>
                          </div>
                        </div>
                        {index < schoolList?.length - 1 && (
                          <div
                            className="w-100 mb-4"
                            style={{ borderTop: "1px solid #ddd" }}
                          ></div>
                        )}
                      </div>
                    ))
                  ) : (
                    <div
                      className="pt-5 pb-5 d-flex align-items-center justify-content-center"
                      style={{ height: "300px" }}
                    >
                      <h4>No data available</h4>
                    </div>
                  )
                ) : (
                  <Card.Body className="min-h-200px">
                    <div className="w-100 d-flex justify-content-center">
                      <Loader loading={loading} />
                    </div>
                  </Card.Body>
                )}
              </Card.Body>
            </Card>
          </Col>

          <Col lg={6}>
            <Card className="bg-white h-100">
              <Card.Header className="d-flex justify-content-between align-items-center">
                <h3 className="card-title fs-20 fw-bolder text-dark">
                  {SidebarTitle.Vendors}
                </h3>
                <a
                  href="/vendors"
                  className="btn fs-16 text-primary btn-link p-0 ms-3"
                >
                  View all
                </a>
              </Card.Header>
              <Card.Body>
                {!vendorloading ? (
                  vendorsList?.length ? (
                    vendorsList?.slice(0, 5)?.map((val: any, index: number) => (
                      <div key={index}>
                        <div className="d-flex align-items-center mb-4">
                          <div className="symbol symbol-50px me-5">
                            <img src={val?.image} alt="Profile" />
                          </div>
                          <div className="flex-grow-1">
                            <div className="text-dark fw-bold fs-6">
                              {val?.name}
                            </div>
                            <span className="text-muted d-block fw-semibold">
                              {Method.convertDateToDDMMYYYYHHMMA(
                                val._createdAt
                              ) || "-"}
                            </span>
                          </div>
                          <div className="ms-auto text-end">
                            <span
                              className={
                                val?.isApproved ? "text-success" : "text-danger"
                              }
                            >
                              {val?.isApproved ? "Approved" : "Not Approved"}
                            </span>
                          </div>
                        </div>
                        {index < vendorsList.slice(0, 5).length - 1 && (
                          <div
                            className="w-100 mb-4"
                            style={{ borderTop: "1px solid #ddd" }}
                          ></div>
                        )}
                      </div>
                    ))
                  ) : (
                    <div
                      className="pt-5 pb-5 d-flex align-items-center justify-content-center"
                      style={{ height: "300px" }}
                    >
                      <h4>No data available</h4>
                    </div>
                  )
                ) : (
                  <Card.Body className="min-h-200px">
                    <div className="w-100 d-flex justify-content-center">
                      <Loader loading={vendorloading} />
                    </div>
                  </Card.Body>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};
export default VendorSchoolRecently;
